import Model from "./Model.js";

/**
 * `UserReference` represents a summary of user information.
 *
 * This model is used where a user model is not available or feasible.
 *
 * Users of this model should be aware that model can be partially populated
 * because underlying user information might be missing/incomplete.
 *
 * E.g. We have cases where we haven't stored username in database.
 *
 * There is no guarantee that every UserReference can uniquely resolve to a user.
 *
 * @param {{}} [my]
 * @param {string} spec.username - user name of the user
 * @param {string} spec.name - display name of the user
 * @param {string} spec.avatarData - avatar data of the user
 * @return {*} periodReport
 */
export default class UserReference extends Model {
	constructor(spec = {}) {
		super(spec);
		this._username = spec.username;
		this._name = spec.name;
		this._avatarData = spec.avatarData;
		this._typeOfUser = spec.typeOfUser;
	}

	getName() {
		return this._name;
	}

	getUsername() {
		return this._username;
	}

	getAvatarData() {
		return this._avatarData;
	}

	isUnnamed() {
		return !this._name;
	}

	isUnknownUser() {
		return this._typeOfUser === "UnknownUser"; // ¯\_(ツ)_/¯
	}

	isCompanyUser() {
		return this._typeOfUser === "Presentation"; // ¯\_(ツ)_/¯
	}

	static transformMaterializationData(data) {
		data.username = data.userName;
	}
}
